import React, { useEffect, useState } from "react";
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Grid, Typography, Checkbox, Box, Button
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useNavigate, useLocation } from "react-router-dom";
import SearchBar from "../../../Common/UtilityCommon/SearchBar";
import PerPageSelect from "../../../Common/UtilityCommon/PerPageSelect";
import Pagination from "../../../Common/UtilityCommon/Pagination";
import CircularSpinner from "../../../Common/Spinners/CircularSpinner";
import axios from "axios";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';

const styles = {
    tableHeaderCell: {
        fontSize: "16px",
        fontWeight: "bold",
        backgroundColor: "#f4f4f4",
        whiteSpace: "nowrap",
        position: "sticky",
        top: 0,
        zIndex: 1,
    },
};

//API URL
const API_URL = process.env.REACT_APP_API;

const ReadyForSale = ({ includeYearCode = true,
    rowKey = "AwakDetailId",
}) => {

    const [rows, setRows] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [perPage, setPerPage] = useState(15);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedRows, setSelectedRows] = useState({});
    const [rejectRows, setRejectRows] = useState({});

    const [selectedHelpRows, setSelectedHelpRows] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const navigatedRecord = searchParams.get('navigatedRecord');

    const paginatedPosts = filteredRows.slice((currentPage - 1) * perPage, currentPage * perPage);

    const apiUrl = `${process.env.REACT_APP_API}/getdata-ReadyforSale`;

    const columns = [
        { label: "Sr No", key: "SrNo" },
        { label: "Detail ID", key: "AwakDetailId" },
        { label: "Awak No", key: "Doc_No" },
        { label: "Awak Date", key: "Doc_Date" },
        { label: "Farmer Code", key: "Ac_code" },
        { label: "Farmer Name", key: "Ac_Name_E" },
        { label: "Farmer Mobile No", key: "FarmerMobile" },
        { label: "Item", key: "Item" },
        { label: "Awak Qty", key: "Awak_Qty" },
        { label: "Godown", key: "Godown" },
        { label: "Line", key: "Line" },
        { label: "Balance", key: "balance" },
        { label: "Customer Code", key: "Customer_Code" },
        { label: "Customer Name", key: "CustomerName" },
        { label: "Customer Mobile No", key: "CustomerMobile" },
        { label: "Sale Rate", key: "Salerate" },

    ];


    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            setLoading(true);

            const Company_Code = sessionStorage.getItem("Company_Code");
            const Year_Code = sessionStorage.getItem("Year_Code");

            const finalUrl = `${apiUrl}?Company_Code=${Company_Code}${includeYearCode ? `&Year_Code=${Year_Code}` : ""}`;

            const res = await axios.get(finalUrl);
            const data = res.data.all_data || [];

            setRows(data);
            setFilteredRows(data);

            // Preselect already ticked rows
            const preSelected = {};
            data.forEach(row => {
                if (row.Readyforsale === "Y") {
                    preSelected[row[rowKey]] = true;
                }
            });
            setSelectedRows(preSelected);

        } catch (err) {
            console.error("Error fetching:", err);
        } finally {
            setLoading(false);
        }
    };

    // const handleRowToggle = (rowId) => {
    //     setSelectedRows((prev) => ({
    //         ...prev,
    //         [rowId]: !prev[rowId]
    //     }));
    // };
    const handleRowToggle = (rowId) => {
        setSelectedRows(prev => {
            const newValue = !prev[rowId];

            // If ReadyForSale is selected → uncheck Reject
            if (newValue) {
                setRejectRows(prevReject => ({
                    ...prevReject,
                    [rowId]: false
                }));
            }

            return {
                ...prev,
                [rowId]: newValue
            };
        });
    };


    const handleRejectToggle = (rowId) => {
        setRejectRows(prev => {
            const updated = { ...prev, [rowId]: !prev[rowId] };

            // If Reject = YES → remove from ReadyForSale
            if (updated[rowId]) {
                setSelectedRows(prevSel => ({
                    ...prevSel,
                    [rowId]: false
                }));
            }

            return updated;
        });
    };


    useEffect(() => {
        const term = searchTerm.toLowerCase();

        const filtered = rows.filter((row) =>
            Object.values(row).some((val) =>
                String(val).toLowerCase().includes(term)
            )
        );
        const sorted = [...filtered].sort((a, b) => {
            const aChecked = !!selectedRows[a[rowKey]];
            const bChecked = !!selectedRows[b[rowKey]];

            if (!aChecked && bChecked) return -1;
            if (aChecked && !bChecked) return 1;
            return 0;
        });

        setFilteredRows(sorted);
        // setRows(sorted);
        setCurrentPage(1);

        // setFilteredRows(filtered);
        // setCurrentPage(1);
    }, [searchTerm, rows]);

    const pageCount = Math.ceil(filteredRows.length / perPage);
    const paginatedRows = filteredRows.slice(
        (currentPage - 1) * perPage,
        currentPage * perPage
    );

    const allReadySelected =
        filteredRows.length > 0 &&
        filteredRows.every(row => selectedRows[row[rowKey]]);

    const someReadySelected =
        filteredRows.some(row => selectedRows[row[rowKey]]) && !allReadySelected;

    const handleHelpSelect = (row) => {
        setSelectedHelpRows(prev => {
            if (prev.some(r => r.AwakDetailId === row.AwakDetailId)) return prev;
            return [...prev, row];
        });
    };

    const handleCarryToAuction = async () => {
        const company_code = sessionStorage.getItem("Company_Code");
        const year_code = sessionStorage.getItem("Year_Code");

        const today = new Date().toISOString().split("T")[0];   // yyyy-mm-dd

        const detailData = rows.map(row => {
            const id = Number(row[rowKey]);
            const isSelected = selectedRows[id];
            const isRejected = rejectRows[id];

            // === If Rejected ===
            if (isRejected) {
                return {
                    Id: id,
                    Readyforsale: "N",
                    AuctionMark: "N",
                    Customer_Code: 0,
                    cc: 0,
                    Salerate: 0,
                    SrNo: 0,
                    // ApprovedDate: null,
                    RejectDate: today,
                    rowaction: "update"
                };
            }

            // Ready for Sale
            if (isSelected) {
                return {
                    Id: id,
                    Readyforsale: "Y",
                    AuctionMark: row.AuctionMark,
                    Customer_Code: row.Customer_Code,
                    cc: row.cc,
                    Salerate: row.Salerate,
                    SrNo: row.SrNo,
                    ApprovedDate: today,
                    // RejectDate: null,
                    rowaction: "update"
                };
            }

            //  Neither selected
            // return {
            //     Id: id,
            //     Readyforsale: "N",
            //     AuctionMark: row.AuctionMark,
            //     Customer_Code: row.Customer_Code,
            //     cc: row.cc,
            //     Salerate: row.Salerate,
            //     SrNo: row.SrNo,
            //     ApprovedDate: null,
            //     RejectDate: null,
            //     rowaction: "update"
            // };

        });

        try {
            const res = await axios.put(
                `${API_URL}/Update_DetailForReadyForSaleAwakEntry`,
                { detailData }
            );

            Swal.fire({
                title: "Success!",
                text: "Updated",
                icon: "success"
            });

            setTimeout(() => window.location.reload(), 1000);

        } catch (err) {
            console.error(err);
            alert("Saving failed");
        }
    };





    const handleExportToExcel = () => {
        if (rows.length === 0) {
            Swal.fire({ title: "No data!", text: "Please select rows first.", icon: "warning" });
            return;
        }


        const wb = XLSX.utils.book_new();

        const excelRows = [];


        excelRows.push(["Awak No", "Awak Date", "Farmer Code", "Farmer Name", "Item", "Awak Qty", "Customer Code", "Customer Name", "Sale Rate", "Ready For Sale", "Reject"]);


        filteredRows.forEach((row, index) => {
            excelRows.push([
                row.Doc_No,
                row.Doc_Date,
                row.Ac_code,
                row.Ac_Name_E,
                row.Item,
                row.Awak_Qty,
                row.Customer_Code,
                row.CustomerName,
                row.Salerate,
                selectedRows[row[rowKey]] ? "✔" : "✖",
                rejectRows[row[rowKey]] ? "✔" : "✖",
            ]);
        });


        const ws = XLSX.utils.aoa_to_sheet(excelRows);


        XLSX.utils.book_append_sheet(wb, ws, "SelectedData");

        XLSX.writeFile(wb, "SelectedData.xlsx");
    };

    const handleSelectAllReadyForSale = (event) => {
        const checked = event.target.checked;

        const newSelected = { ...selectedRows };
        const newReject = { ...rejectRows };

        filteredRows.forEach((row) => {
            const id = row[rowKey];
            newSelected[id] = checked;

            if (checked) {
                newReject[id] = false;
            }
        });

        setSelectedRows(newSelected);
        setRejectRows(newReject);
    };


    return (
        <>
            {/* ==================== HEADER SECTION ===================== */}
            <Grid container spacing={2} alignItems="center">
                <Grid item>
                    <PerPageSelect value={perPage} onChange={(e) => {
                        setPerPage(e.target.value);
                        setCurrentPage(1);
                    }} />
                </Grid>

                <Grid item>
                    <Button
                        variant="contained"
                        onClick={handleExportToExcel}
                        style={{
                            backgroundColor: "#3c9a43ff",
                            color: "white",
                            textTransform: "none",
                            fontWeight: "600",
                            padding: "6px 16px",
                            borderRadius: "6px",
                            boxShadow: "none",
                            marginTop: "2px",

                        }}
                        startIcon={<FileDownloadIcon />}
                    >
                        Export to Excel
                    </Button>
                </Grid>

                <Grid item xs display="flex" justifyContent="left">
                    <Typography
                        variant="h6"
                        sx={{
                            textAlign: 'center',
                            fontSize: '1.2rem',
                            fontWeight: 'bold',
                            color: '#2c3e50',
                            ml: 67,
                            marginBottom: '10px',
                            padding: '12px 0',
                            position: 'relative',
                            '&::after': {
                                content: '""',
                                position: 'absolute',
                                bottom: '0',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: '80px',
                                height: '4px',
                                background: 'linear-gradient(90deg, #3498db, #2ecc71)',
                                borderRadius: '2px',
                                animation: 'underlineGrow 0.5s ease-out forwards'
                            },
                            '@keyframes underlineGrow': {
                                '0%': { width: '0' },
                                '100%': { width: '80px' }
                            }
                        }}
                    >
                        Ready For Sale
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <SearchBar value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                </Grid>
            </Grid>

            {/* ==================== TABLE ===================== */}
            <Paper sx={{ mt: 2 }}>
                <TableContainer sx={{ maxHeight: "70vh" }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow
                                sx={{
                                    height: 32,        // Header row height
                                }}
                            >
                                {columns.map((column, index) => (
                                    <TableCell
                                        key={index}
                                        sx={{
                                            ...styles.tableHeaderCell,
                                            textAlign: column.format ? "right" : "left",
                                            padding: "4px 6px",
                                            fontSize: "14px",
                                            height: "32px",
                                        }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}

                                <TableCell
                                    sx={{
                                        ...styles.tableHeaderCell,
                                        textAlign: "center",
                                        padding: "4px 6px",
                                        fontSize: "14px",
                                        height: "32px",
                                        width: "60px"
                                    }}
                                >
                                    Ready For Sale
                                    <Checkbox
                                        size="small"
                                        checked={allReadySelected}
                                        onChange={handleSelectAllReadyForSale}
                                        sx={{ padding: "0px", marginLeft: "4px" }}
                                    />
                                </TableCell>

                                <TableCell
                                    sx={{
                                        ...styles.tableHeaderCell,
                                        textAlign: "center",
                                        padding: "4px 6px",
                                        fontSize: "14px",
                                        height: "32px",
                                        width: "60px"
                                    }}
                                >
                                    Reject
                                </TableCell>


                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {loading ? (
                                <TableRow>
                                    <TableCell colSpan={columns.length} align="center">
                                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 400 }}>
                                            <CircularSpinner />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ) : paginatedPosts.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={20} align="center" style={{ fontSize: "16px", fontWeight: "bold" }}>
                                        No data found...
                                    </TableCell>
                                </TableRow>
                            ) : (
                                paginatedPosts.map((post) => (
                                    <TableRow
                                        key={post[rowKey]}
                                        onDoubleClick={() => handleRowToggle(post[rowKey])}
                                        sx={{
                                            cursor: "pointer",
                                            transition: "background-color 0.3s ease",
                                            "&:hover": {
                                                backgroundColor: "#f3f388",
                                            },
                                            height: 28,       // Row height (reduced)
                                        }}
                                    >
                                        {columns.map((column, index) => (
                                            <TableCell
                                                key={index}
                                                sx={{
                                                    whiteSpace: "nowrap",
                                                    textAlign: column.format ? "right" : "left",
                                                    padding: "3px 6px",      // Row padding reduced
                                                    fontSize: "13px",        // Row font size
                                                    height: "28px",          // Row cell height
                                                }}
                                            >
                                                {column.format
                                                    ? formatReadableAmount(post[column.key])
                                                    : post[column.key]}
                                            </TableCell>
                                        ))}
                                        <TableCell padding="checkbox" sx={{ textAlign: "center" }}>
                                            <Checkbox
                                                size="small"
                                                checked={!!selectedRows[post[rowKey]]}
                                                onChange={() => handleRowToggle(post[rowKey])}   // clicking checkbox also toggles
                                                onClick={(e) => e.stopPropagation()}             // prevents triggering row double-click
                                            />
                                        </TableCell>

                                        {/* Reject Checkbox */}
                                        <TableCell padding="checkbox" sx={{ textAlign: "center" }}>
                                            <Checkbox
                                                size="small"
                                                checked={!!rejectRows[post[rowKey]]}
                                                onChange={() => handleRejectToggle(post[rowKey])}
                                                onClick={(e) => e.stopPropagation()}
                                            />
                                        </TableCell>


                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>


                </TableContainer>
            </Paper>

            <Box mt={2} display="flex" justifyContent="center">
                <button
                    onClick={handleCarryToAuction}
                    style={{
                        padding: "10px 25px",
                        backgroundColor: "#3498db",
                        color: "white",
                        fontSize: "16px",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer"
                    }}
                >
                    Update
                </button>
            </Box>


            {/* ==================== PAGINATION ===================== */}
            <Box mt={3} mb={5}>
                <Pagination
                    pageCount={pageCount}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                />
            </Box>
        </>
    );
};

export default ReadyForSale;
